/**
 * Poll wiring.
 *
 * The vote itself is core-common's `PollForm` global. This module supplies the
 * callbacks and toggles between the question and the results panel.
 *
 * `hidden` is toggled rather than a class, so the results panel is genuinely
 * out of the accessibility tree and the tab order while the question is up.
 */
import { qs, on } from './dom.js';

const t = (key) => (window.i18n && window.i18n[key]) || '';

export function setupPoll() {
  const root = qs('[data-poll]');
  if (!root) return;

  const form = qs('[data-poll-form]', root);
  const question = qs('[data-poll-question]', root);
  const panel = qs('[data-poll-results-panel]', root);
  const status = qs('[data-poll-status]', root);

  if (!form || !question || !panel) return;

  const showResults = (show) => {
    question.hidden = show;
    panel.hidden = !show;
  };

  on(qs('[data-poll-results]', root), 'click', () => showResults(true));
  on(qs('[data-poll-back]', root), 'click', () => showResults(false));

  // Without PollForm the markup stays a readable question and the results
  // button still works if the engine already rendered them. Better than a throw.
  if (typeof window.PollForm !== 'function') return;

  const say = (message, tone) => {
    if (!status) return;
    status.textContent = message;
    // Tailwind classes rather than a bespoke .red-text/.green-text pair, which
    // is what base_neo uses and what nothing defines any more.
    status.classList.toggle('text-magenta', tone === 'error');
    status.classList.toggle('text-gold-ink', tone === 'ok');
  };

  new window.PollForm(form, {
    onSubmit: () => say(t('sending'), null),
    // The engine rejects a second vote from the same visitor; that is the
    // common case here, not an unexpected error.
    onError: () => say(t('onceVote'), 'error'),
    onSuccess: () => {
      say(t('pollVoteOk'), 'ok');
      showResults(true);
    },
  });
}
